import { render, staticRenderFns } from "./ComponentSpinner.vue?vue&type=template&id=12d05daa&scoped=true&"
import script from "./ComponentSpinner.vue?vue&type=script&lang=js&"
export * from "./ComponentSpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d05daa",
  null
  
)

export default component.exports